{
  "titles": {
    "menuTitle": "Berichtenbox",
    "pageTitle": "Berichtenbox"
  },
  "messages": {
    "noMessages": "Je hebt nog geen berichten."
  }
}
